<template>
  <FocusTrap>
    <div class="card">

      <div class="card-header header-elements-inline" style="background-color: whitesmoke; padding: 10px;">
        <h5 v-if="rawmaterial.id == 0" class="card-title">Raw Material Creation</h5>
        <h5 v-if="rawmaterial.id > 0" class="card-title"> Raw Material Updation</h5>
        <div class="header-elements">
          <div class="list-icons">
            <a class="list-icons-item" data-action="reload" ></a>
            <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
          </div>
        </div>
      </div>


      <div class="card-body">
        <p/>
      <form action="#">

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Name:</label>
          <div class="col-md-10">
            <input  id="txtname" ref="txtname"  type="text" class="form-control" placeholder="Enter Raw Material Name here..." maxlength="100" v-if="rawmaterial" v-model="rawmaterial.name" autocomplete="off" >
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Type:</label>
          <div class="col-md-10">
            <select class="form-control" required="" v-if="rawmaterial" v-model="rawmaterial.type">
              <option value="0" selected="selected">Default</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Print Name:</label>
          <div class="col-md-10">
            <input type="text" class="form-control" placeholder="Enter print name here..." maxlength="100" v-if="rawmaterial" v-model="rawmaterial.print_name">
          </div>
        </div>

      </form>
    </div>

    <div class="card-footer">
      <div class="text-right" >
        <button type="button" class="btn btn-primary" @click="saveDocument" >Save<i class="icon-paperplane ml-2"></i></button>
      </div>
    </div>
  </div>
  </FocusTrap>
</template>

<script>
import {userService} from '@/store/auth-header.js';
import moment from 'moment-timezone'
import { store } from '@/store/store.js'

export default {
  name: 'RawMaterialForm',
  store,
  data () {
    return {
      rawmaterial: JSON.parse('{"id":0,"type":0,"name":"","print_name":"","project_id":1}')
    }
  },
  props: {
    myrawmaterial: {
      type: Object,
      required: true,
      default: JSON.parse('{"id":0,"type":0,"name":"","print_name":"","project_id":1}')
    }
  },
  beforeMount () {
    this.rawmaterial = this.myrawmaterial; // save props data to itself's data and deal with tms
  },

  component: {

  },
  created () {
    this.$data.rawmaterial = JSON.parse('{"id":0,"type":0,"name":"","print_name":"","project_id":1}')
  },
  mounted () {
    const self = this;
    //$('#txtname').focus();
    self.$refs.txtname.focus();
  },
  methods: {
    closeWindow(){
      this.$emit('rawmaterial_window_closed');
      this.$modal.hide('rawmaterial_window');
      this.rawmaterial = JSON.parse('{"id":0,"type":0,"name":"","print_name":"","project_id":1}');
    },
    clear(){
      this.$data.rawmaterial = JSON.parse('{"id":0,"type":0,"name":"","print_name":"","project_id":1}')
    },

    saveDocument(){
      const self = this;

      if(self.$data.rawmaterial.name.trim().length < 1){
        alert("Invalid Name");
        return
      }

      self.$data.rawmaterial.type = parseInt(self.$data.rawmaterial.type);

      const requestOptions = {
        method:  (self.$data.rawmaterial.id == 0 ? 'POST' : 'PUT'),
        mode:"cors",
        headers: userService.authHeader(),
        body: JSON.stringify(self.$data.rawmaterial)
      };

      fetch(`${process.env.VUE_APP_ROOT_API}api/bms/rawmaterial`,requestOptions).then(userService.handleResponse).then(function (resp) {
        if(resp.ok) {
          self.$emit('rawmaterial_saved', resp.data);
          swal ( { title: "Success!" ,  text: resp.msg, type: "success"} );
          self.rawmaterial = JSON.parse('{"id":0,"type":0,"name":"","print_name":"","project_id":1}');
        } else {
          swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
        }
      }).catch(function (err) {
        swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"});
      });
    }
  }
}
</script>

<style scoped>
  input:focus {
    background: #feff00;

  }

  textarea:focus {
    background: #feff00;

  }

  select:focus {
    background: #feff00;
  }

  button:focus {
    background: #feff00;
    color: #0a0a0a!important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>
